import { render, staticRenderFns } from "./AllMailboxes.vue?vue&type=template&id=05a6e9e5&"
import script from "./AllMailboxes.vue?vue&type=script&lang=ts&"
export * from "./AllMailboxes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports